import type { PostHogInterface } from "posthog-js";

export const ORIGINAL_REFERRER_QUERY_PARAM = "orig_ref";

const DIRECT_REFERRER = "$direct";

export interface OriginalReferrerAttribution {
  $referrer: string;
  $referring_domain: string;
  marketing_site_hop?: string;
}

const isHttpUrl = (value: URL): boolean => value.protocol === "http:" || value.protocol === "https:";

export const getOriginalReferrerAttribution = (
  search: string,
  documentReferrer = "",
): OriginalReferrerAttribution | undefined => {
  const origRef = new URLSearchParams(search).get(ORIGINAL_REFERRER_QUERY_PARAM)?.trim();
  if (!origRef || origRef === DIRECT_REFERRER) {
    return undefined;
  }

  try {
    const url = new URL(origRef);
    if (!url.hostname || !isHttpUrl(url)) {
      return undefined;
    }

    return {
      $referrer: origRef,
      $referring_domain: url.hostname,
      ...(documentReferrer ? { marketing_site_hop: documentReferrer } : {}),
    };
  } catch {
    return undefined;
  }
};

export const applyOriginalReferrerAttribution = (
  client: Pick<PostHogInterface, "register" | "register_for_session">,
  search = window.location.search,
  documentReferrer = document.referrer,
): void => {
  const attribution = getOriginalReferrerAttribution(search, documentReferrer);
  if (!attribution) {
    return;
  }

  // Super properties are what PostHog dashboards read for $referrer. Session
  // persistence is required too: capture() register_once's document.referrer
  // onto the session store, which otherwise wins the event-property merge.
  client.register(attribution);
  client.register_for_session({
    $referrer: attribution.$referrer,
    $referring_domain: attribution.$referring_domain,
  });
};
